var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.config.name,{ref:"form",tag:"component",attrs:{"format":_vm.config.format,"items":_vm.config.items,"option":_vm.config.options,"columns":_vm.config.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }